<template>
  <div>
    <div class="loan_wrapper " v-loading="loading" :class="!isPc ? 'mobile' : 'pc'">
    <NavM :title="$t('loan.title')" v-if="!isPc" />
      <div class="loan_borrow" :class="!isPc ? 'mobile' : 'pc'">
        <div class="money_content">
          <div class="money_value">1,000,000 USD</div>
          <div class="ver_status_content">
            <div class="status_not">
              <div class="ver_tips">
                <span>{{ $t('loan.notVerifyTip') }}！</span>
              </div>
              <div class="ver_button" v-if="!isLogin || userInfo.idefinderStatus != '1'">
                <div class="button  round" :class="!isPc ? 'black' : 'yellow'"  @click="showAccreditationChange" style="padding: 0px 22px;width:auto">
                  <span style="font-size: 18px">{{ $t('loan.notVerifyBtn') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="select_button_content">
          <div class="select_button">
            <input type="text" :placeholder="$t('loan.borrowPlaceholder')"
              onkeyup="this.value=this.value.replace(/[^\d.]/g,'')" v-model="money"
              onafterpaste="this.value=this.value.replace(/[^\d.]/g,'')" />
            <div class="select">
              <span>USD</span>
            </div>
          </div>
          <div class="select_button">
            <div class="label">{{ $t('loan.term') }}:</div>
            <div class="select finger-dark" @click="showDays = true">
              <span>{{ dayList[dayindex] && dayList[dayindex].days }} {{ $t('loan.days') }}</span><img class="icon_arrow"
                src="@/assets/img/icon_arrow.dc4b9070.svg" alt="" />
            </div>
            <div class="select_options" v-show="showDays">
              <div class="option  finger-dark" @click="dayChange(index)" :class="{ active: dayindex === index }"
                v-for="(item, index) in dayList" :key="index">{{ item.days }} {{ $t('SmartTrading.days') }}</div>
              <!-- <div class="option finger-dark">10 天</div>
              <div class="option">15 天</div> -->
            </div>

          </div>
        </div>
        <div class="info_content">
          <div class="info_item">
            <div class="title">{{ $t('loan.dailyRate') }}:</div>
            <div class="content">{{ dayList[dayindex] && dayList[dayindex].rate }}%</div>
          </div>
          <div class="info_item">
            <div class="title">{{ $t('loan.totalAmount') }}:</div>
            <div class="content">{{ loanRatePrice }} USD</div>
          </div>
          <div class="tips">
            <p>
              {{ $t('daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi',{num:loan_rate_begin_time}) }}
              <!-- 贷款后{{ loan_rate_begin_time }}天内无需支付利息，{{ loan_rate_begin_time }}天后需支付利息。  -->
                <br /></p>
          </div>
        </div>
        <div class="button_content">
          <!-- ✅ 两个按钮并排居中显示 -->
          <div class="button black round" @click="loan">
            <span style="font-size: 18px">{{ $t('loan.borrowNow') }}</span>
          </div>
          <div class="button black round" @click="openLoan">
            <span style="font-size: 18px">{{ $t('dai-kuan-ji-lu') }}</span>
          </div>
        </div>
      </div>
    </div>
    <Accreditation v-if="showAccreditation" @hide="showAccreditation = false"></Accreditation>
    <div class="loan-main" :class="!isPc ? 'loan-main-mobiles' : ''" v-show="loanShow" @click.stop="loanClose">
			<div class="step1_content" @click.stop="">
				<div class="loan_title">{{ $t('loan.loanDetail') }}</div>
				<div class="collapse">
					<div class="collapse-content" v-for="(item, index) in listData" :key="index">
						<div class="content-header">
							<!-- ✅ 顶部：订单号和状态 -->
							<div class="order-top">
								<div class="order-number">#{{ item.id }}</div>
								<div class="order-status">
									<span class="status-badge status-pending" v-if="item.status == 0">
										{{ $t('daiShenHe') }}
									</span>
									<span class="status-badge status-processing" v-if="item.status == 1">
										{{ $t('huanKuanZhong') }}
									</span>
									<span class="status-badge status-success" v-if="item.status == 2">
										{{ $t('yiHuanKuan') }}
									</span>
									<span class="status-badge status-rejected" v-if="item.status == 3">
										{{ $t('yiJuJue') }}
									</span>
								</div>
							</div>
							
							<!-- ✅ 贷款信息：清晰的两列布局 -->
							<div class="loan-details">
								<div class="detail-row">
									<span class="detail-label">{{ $t('dai-kuan-jin-e') }}</span>
									<span class="detail-value highlight">{{ item.amount }} USD</span>
								</div>
								<div class="detail-row">
									<span class="detail-label">{{ $t('ri-li-shuai') }}</span>
									<span class="detail-value">{{ item.rete }}%</span>
								</div>
								<div class="detail-row">
									<span class="detail-label">{{ $t('zongLiXi') }}</span>
									<span class="detail-value">{{ item.interest }} USD</span>
								</div>
								<div class="detail-row">
									<span class="detail-label">{{ $t('dangQianLiXi') }}</span>
									<span class="detail-value">{{ item.currentInterest }} USD</span>
								</div>
								<div class="detail-row">
									<span class="detail-label">{{ $t('jiXiShiJian') }}</span>
									<span class="detail-value">{{ item.beginDay }}</span>
								</div>
								<div class="detail-row">
									<span class="detail-label">{{ $t('daoQiShiJian') }}</span>
									<span class="detail-value">{{ item.maturityDate }}</span>
								</div>
							</div>
							
							<!-- ✅ 申请时间 -->
							<div class="order-time">{{ item.createTime }}</div>
						</div>
					</div>

				</div>
				<div class="show-more">
					<div class="finger-dark" v-if="loadingStatus == 1" @click="loadMore()">
						<span>{{ $t('account.expandMore') }}</span>
						<img src="@/assets/img/icon_arrow.dc4b9070.svg" alt="">
					</div>
					<div v-if="loadingStatus == 0"><span>{{ $t('toast.noData') }}</span></div>
				</div>
			</div>
		</div>
		
		<!-- 成功提示弹窗 -->
		<SuccessModal ref="successModal" :message="successMessage" :duration="2000" />
  </div>
</template>
      
<script>
// @ is an alias to /src
import NavM from "@/components/nav_m.vue";
import SuccessModal from "@/components/SuccessModal.vue";
import { mapGetters ,mapState} from 'vuex'
import { DatePicker } from 'element-ui';
import Accreditation from "@/components/Accreditation.vue";
import { loan,listLoanRecord } from "@/api/user";
import { getParamByKey } from "@/api/market";
// import 'element-ui/lib/theme-chalk/index.css';
export default {
  computed: {
    ...mapState(["isLogin", "userInfo","isPc"]),
    ...mapGetters(["getUserInfo"]),
    // 总利息金额
    loanRatePrice() {
      // //console.log(111);
      if (this.dayList[this.dayindex]&&this.dayList[this.dayindex].days&&this.dayList[this.dayindex].rate&&this.money) {
        // 贷款期限-贷款计息开始时间 * 日利率 * 金额
        let day=this.dayList[this.dayindex]&&this.dayList[this.dayindex].days||0;
        let rate=this.dayList[this.dayindex]&&this.dayList[this.dayindex].rate||0;
        // //console.log((day-this.loan_rate_begin_time));
        return (day-this.loan_rate_begin_time)*rate*this.money/100;
      } else {
        return 0

      }

    },
    // 性别列表
    sexLIst() {
      [
        { name: this.$t('loan.male'), value: "1" },
        { name: this.$t('loan.female'), value: "2" },
      ]

    },
    // 证件列表
    cardLIst(){
      return [
      { name: this.$t('loan.idCard'), value: "1" },
      { name: this.$t('loan.passport'), value: "2" },
    ]
    },

  },
  data() {
    return {
      loading: false,
      mask: false,
      showAccreditation: false,
      loadingStatus: 2,
      money: '',
      successMessage: '', // 成功提示消息
      // 区号列表
      codeList: [
        { label: "United States +1", value: "1" },
        { label: "Canada +1", value: "1" },
        { label: "United Kingdom +44", value: "44" },
        { label: "Australia +61", value: "61" },
        { label: "Germany +49", value: "49" },
        { label: "France +33", value: "33" },
        { label: "China +86", value: "86" },
        { label: "Japan +81", value: "81" },
        { label: "India +91", value: "91" },
        { label: "Brazil +55", value: "55" },
        { label: "Mexico +52", value: "52" },
        { label: "South Korea +82", value: "82" },
        { label: "Russia +7", value: "7" },
        { label: "South Africa +27", value: "27" },
        { label: "Nigeria +234", value: "234" },
        { label: "Egypt +20", value: "20" },
        { label: "Saudi Arabia +966", value: "966" },
        { label: "United Arab Emirates +971", value: "971" },
        { label: "Singapore +65", value: "65" },
        { label: "New Zealand +64", value: "64" },
        { label: "Argentina +54", value: "54" },
        { label: "Chile +56", value: "56" },
        { label: "Colombia +57", value: "57" },
        { label: "Peru +51", value: "51" },
        { label: "Turkey +90", value: "90" },
        { label: "Italy +39", value: "39" },
        { label: "Spain +34", value: "34" },
        { label: "Portugal +351", value: "351" },
        { label: "Greece +30", value: "30" },
        { label: "Netherlands +31", value: "31" },
        { label: "Belgium +32", value: "32" },
        { label: "Switzerland +41", value: "41" },
        { label: "Sweden +46", value: "46" },
        { label: "Norway +47", value: "47" },
        { label: "Denmark +45", value: "45" },
        { label: "Finland +358", value: "358" },
        { label: "Poland +48", value: "48" },
        { label: "Austria +43", value: "43" },
        { label: "Czech Republic +420", value: "420" },
        { label: "Hungary +36", value: "36" },
        { label: "Romania +40", value: "40" },
        { label: "Bulgaria +359", value: "359" },
        { label: "Croatia +385", value: "385" },
        { label: "Slovakia +421", value: "421" },
        { label: "Slovenia +386", value: "386" },
        { label: "Serbia +381", value: "381" },
        { label: "Montenegro +382", value: "382" },
        { label: "Bosnia and Herzegovina +387", value: "387" },
        { label: "Macedonia +389", value: "389" },
        { label: "Albania +355", value: "355" },
        { label: "Kosovo +383", value: "383" },
        { label: "Ukraine +380", value: "380" },
        { label: "Belarus +375", value: "375" },
        { label: "Moldova +373", value: "373" },
        { label: "Latvia +371", value: "371" },
        { label: "Estonia +372", value: "372" },
        { label: "Lithuania +370", value: "370" },
        { label: "Georgia +995", value: "995" },
        { label: "Armenia +374", value: "374" },
        { label: "Azerbaijan +994", value: "994" },
        { label: "Kazakhstan +7", value: "7" },
        { label: "Uzbekistan +998", value: "998" },
        { label: "Turkmenistan +993", value: "993" },
        { label: "Kyrgyzstan +996", value: "996" },
        { label: "Tajikistan +992", value: "992" },
        { label: "Afghanistan +93", value: "93" },
        { label: "Pakistan +92", value: "92" },
        { label: "Bangladesh +880", value: "880" },
        { label: "Sri Lanka +94", value: "94" },
        { label: "Maldives +960", value: "960" },
        { label: "Myanmar +95", value: "95" },
        { label: "Thailand +66", value: "66" },
        { label: "Malaysia +60", value: "60" },
        { label: "Vietnam +84", value: "84" },
        { label: "Indonesia +62", value: "62" },
        { label: "Philippines +63", value: "63" },
        { label: "Cambodia +855", value: "855" },
        { label: "Laos +856", value: "856" },
        { label: "Brunei +673", value: "673" },
        { label: "Timor-Leste +670", value: "670" },
        { label: "Papua New Guinea +675", value: "675" },
        { label: "Solomon Islands +677", value: "677" },
        { label: "Vanuatu +678", value: "678" },
        { label: "Fiji +679", value: "679" },
        { label: "Tonga +676", value: "676" },
        { label: "Samoa +685", value: "685" },
        { label: "Kiribati +686", value: "686" },
        { label: "Tuvalu +688", value: "688" },
        { label: "Nauru +674", value: "674" },
        { label: "Marshall Islands +692", value: "692" },
      ],
      // 邮箱显示隐藏
      phoneShow: false,
      // 期限显示
      limitShow: false,
      limit: 0,
      // 验证身份表单
      formData: {
        phone: "",
        code: "",
        sex: "",
        card: ""

      },

      // 证件显示隐藏
      cardShow: false,

      sexShow: false,
      inputSelect: {},
      dayList: [

      ],
      dayindex: 0,
      showDays: false,
      loan_rate_begin_time: 0,
      pageNo:1,
      listData: [],
			pageSize: 5,
			total: 0,
      loanShow: false,

    };
  },
  mounted() {
    this.formData.code=this.codeList[0].value
    if (this.isLogin) {
      this.$store.dispatch("GET_USER_INFO");
    }
    // loan_rate
    // loan_rate_begin_time
    this.getParamByKey("loan_rate")
    this.getParamByKey("loan_rate_begin_time")

  },
  methods: {
    loan() {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }
      if (!this.userInfo.idefinderStatus) {
        this.$toast({
          message: this.$t("loan.notVerifyTip"),
          type: "warning",
        });
        return;
      }
	  
      if (!this.money) {
        this.$toast({
          message: this.$t('toast.notLoanAmount'),
          type: "warning",
        });
        return;
      }

      let params={
        amount: this.money,
        term: this.dayList[this.dayindex].days,
        rete: this.dayList[this.dayindex].rate,
      };
      this.loading=true
      loan(params).then((res) => {
        if (res.code==200) {
          // 使用 SuccessModal 组件显示成功提示
          this.successMessage = this.$t('tiJiaoChengGong') || '提交成功';
          this.$refs.successModal.show();
          
          this.money=""
          this.dayindex=0
          
          // 🔄 刷新订单记录列表
          if (this.isLogin) {
            this.pageNo = 1;
            this.listData = []; // 清空现有数据
            this.listLoanRecord(); // 重新加载
          }

          // this.$router.push("/loan/loanList");
        }else{
          this.$toast({
            message:this.$t(res.message),
            type: "warning",
          });
        }
      }).finally(() => {
        this.loading=false
      });
    },
    getParamByKey(key) {
      getParamByKey(key).then((res) => {
        // //console.log(res.result);
        if (res.code==200) {
          if (key=="loan_rate") {
            // let result = res.result.paramValue
            if (res.result.paramValue&&res.result.paramValue.indexOf("}")!=-1) {
              let result=JSON.parse(res.result.paramValue)
              this.dayList=result
            } else {
              this.dayList=[]
            }

          }
          if (key=="loan_rate_begin_time") {
            this.loan_rate_begin_time=res.result.paramValue||0
          }
        }
      });
    },


    dayChange(index) {
      this.dayindex=index
      // this.formData.day=this.dayList[index].days
      this.showDays=false
    },
    showAccreditationChange() {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }
      this.showAccreditation=true;
    },
    cardPick(index) {
      this.formData.card=this.cardLIst[index].value;
      // //console.log(this.formData.card);
      this.cardShow=false;
    },
    sexPick(index) {
      // //console.log(111);
      this.formData.sex=this.sexLIst[index].value;
      // //console.log(this.formData.sex);
      this.sexShow=false;
    },
    inputfocus(index) {
      this.inputSelect[index]=true;
      // //console.log(this.inputSelect);
      if (index==3) {
        this.sexShow=true
      }
      if (index==8) {
        this.cardShow=true
      }
      this.$forceUpdate()
    },
    inputblur(index) {
      this.inputSelect[index]=false
      // if (index == 3) {
      //   this.sexShow=false;
      // }
      this.$forceUpdate()
    },
    phoneShowChange() {
      this.phoneShow=!this.phoneShow
    },
    pickCode(index) {
      this.formData.code=this.codeList[index].value
      // //console.log(this.formData.code);
      this.phoneShow=false
    },
    async openLoan() {
			if (this.getUserInfo.loanStatus == 2) {
				return this.$toast({
					message: this.$t('qingQieHuanWeiZhenShiZhangHuCaoZuo'),
					type: "warning"
				});
			}
			this.pageNo = 1;
			await this.listLoanRecord();
			this.loanShow = true;
		},
    async listLoanRecord() {
			listLoanRecord({
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			}).then(res => {
				// //console.log(res.result.records);
				// this.listData=res.result.records;
				this.listData = this.listData.concat(res.result.records);
				this.total = res.result.total;
        if (this.listData.length >= this.total) {
					this.loadingStatus = 0;
				} else {
					this.loadingStatus = 1;
				}
			})
		},
    loanClose() {
			this.loanShow = false;
			this.listData = [];

		},
    loadMore() {
			this.pageNo += 1;
			this.listLoanRecord()
		},
  },
  components: {
    'el-date-picker': DatePicker,
    Accreditation,
    NavM,
    SuccessModal
  },
};
</script>
<style scoped lang="scss">
// @import "../../../assets/public.css";

.loan_wrapper {
  text-align: center;
  padding-top: 0.75rem;
  padding-bottom: 1.04rem;
  background: var(--bg-primary);
  min-height: 100vh;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.loan_wrapper .mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loan_borrow .money_content .money_value {
  font-weight: 700;
  font-size: 0.52rem;
  color: var(--text-primary);
}

.loan_borrow .money_content .ver_status_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loan_borrow .money_content .ver_status_content .status_done {
  margin-top: 0.16rem;
  color: var(--success-color);
  font-size: 0.28rem;
}

.loan_borrow .money_content .ver_status_content .status_not {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loan_borrow .money_content .ver_status_content .status_not .ver_tips {
  margin-top: 0.1rem;
  color: var(--text-secondary);
  font-size: 0.2rem;
}

.loan_borrow .money_content .ver_status_content .status_not .ver_button {
  margin-top: 0.24rem;
  height: 0.5rem;
}

.loan_borrow .select_button_content {
  width: 6.21rem;
  position: relative;
  margin: 0 auto;
  margin-top: 1rem;
}

.loan_borrow .select_button_content .select_button {
  margin-bottom: 0.1rem;
  padding-right: 0.06rem;
  box-sizing: border-box;
  width: 100%;
  height: 0.58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--card-bg);
  box-shadow: 0 0.14rem 0.24rem var(--card-shadow);
  border-radius: 0.16rem;
  overflow: hidden;
}

.loan_borrow .select_button_content .select_button .label {
  padding-left: 0.22rem;
  color: var(--text-primary);
  font-size: 0.14rem;
}

.loan_borrow .select_button_content .select_button input {
  height: 100%;
  min-width: 0.1rem;
  flex: 1;
  box-sizing: border-box;
  padding: 0 0.22rem;
  color: var(--text-primary);
  font-size: 0.14rem;
  caret-color: var(--text-primary);
  background: transparent;
}

.loan_borrow .select_button_content .select_button input::placeholder {
  color: var(--text-secondary);
}

.loan_borrow .select_button_content .select_button .select {
  padding: 0 0.24rem;
  min-width: 0.66rem;
  height: 0.46rem;
  background: var(--bg-secondary);
  border-radius: 0.14rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-primary);
}

.loan_borrow .select_button_content .select_button .select span {
  color: var(--text-primary);
}

.loan_borrow .select_button_content .select_button .select .icon_arrow {
  margin-left: 0.1rem;
  width: 0.08rem;
  height: 0.04rem;
}

.loan_borrow .select_button_content .select_button .select .icon_arrow.active {
  transform: rotate(180deg);
}

.loan_borrow .select_button_content .select_button .select_options {
  position: absolute;
  top: 1.3rem;
  right: 0.06rem;
  background: var(--card-bg);
  color: var(--text-primary);
  box-shadow: 0 0.14rem 0.24rem var(--card-shadow);
  border-radius: 0.16rem;
  overflow: hidden;
}

.loan_borrow .select_button_content .select_button .select_options .option {
  min-width: 0.66rem;
  padding: 0.1rem 0.24rem;
  color: var(--text-primary);
  cursor: pointer;
}

.loan_borrow .select_button_content .select_button .select_options .option.active,
.loan_borrow .select_button_content .select_button .select_options .option:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.loan_borrow .info_content {
  margin-top: 0.65rem;
}

.loan_borrow .info_content .info_item {
  margin-bottom: 0.22rem;
}

.loan_borrow .info_content .info_item .title {
  font-size: 0.18rem;
  color: var(--text-secondary);
}

.loan_borrow .info_content .info_item .content {
  font-size: 0.24rem;
  color: var(--text-primary);
  font-weight: 700;
  margin-top:5px
}

.loan_borrow .info_content .tips {
  margin-top: 0.22rem;
  font-size: 0.16rem;
  color: var(--text-secondary);
}

/* ✅ 两个按钮居中显示并添加间距 */
.loan_borrow .button_content {
  margin-top: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.loan_borrow .button_content .button {
  height: 50px;
  padding: 0 36px;
  min-width: 180px;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup_index {
  background: var(--card-bg);
  border-radius: 0.18rem;
}

.popup {
  padding: 0.44rem;
  width: 8.62rem;
  box-sizing: border-box;
}

.popup .title {
  margin-bottom: 0.48rem;
  text-align: left;
  font-weight: 700;
  font-size: 0.34rem;
  color: var(--text-primary);
}

.popup .step1_content {
  margin-bottom: 0.18rem;
  display: flex;
  flex-wrap: wrap;
}

.popup .step1_content .input_item {
  margin-bottom: 0.22rem;
  width: 3.8rem;
}

.popup .step1_content .input_item:nth-child(odd) {
  margin-right: 0.14rem;
}

.popup .step2_content {
  margin-bottom: 0.4rem;
  display: flex;
  justify-content: space-between;
}

.popup .step2_content .phone_item:first-child {
  margin-right: 0.34rem;
}

.popup .step2_content .phone_item .item_title {
  padding: 0 0.4rem;
  margin-bottom: 0.22rem;
  font-weight: 500;
  font-size: 0.22rem;
  color: var(--text-primary);
}

.popup .step2_content .phone_item .item_upload {
  padding: 0.24rem 0;
  border: 0.01rem dashed #000;
  border-radius: 0.2rem;
  text-align: center;
}

.popup .step2_content .phone_item .item_upload .file_input {
  display: none;
}

.popup .step2_content .phone_item .item_upload .upload_tips {
  color: var(--text-primary);
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip {
  font-size: 0.18rem;
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip span {
  cursor: pointer;
  color: #4d4fff;
}

.popup .step2_content .phone_item .item_upload .upload_tips .sub_tip {
  margin-top: 0.1rem;
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.14rem;
}

.popup .step2_content .phone_item .item_upload_resilt {
  width: 0.72rem;
  height: 0.72rem;
}

.popup .step3_content {
  margin-bottom: 0.4rem;
  padding: 0.24rem 0.44rem 0.36rem 0.44rem;
  border: 0.01rem solid #000;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup .step3_content .item_upload_resilt {
  width: 3.78rem;
  height: 1.72rem;
}

.popup .step3_content .file_input {
  display: none;
}

.popup .step3_content .idcard_content {
  margin-bottom: 0.18rem;
  width: 1.26rem;
  height: 1.26rem;
  background: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup .step3_content .idcard_content img {
  width: 0.6rem;
  height: 0.6rem;
}

.popup .step3_content .idcard_img {
  margin-bottom: 0.18rem;
  width: 1.26rem;
  height: 1.26rem;
}

.popup .step3_content .tips {
  margin-bottom: 0.18rem;
  padding: 0 0.8rem;
  font-weight: 400;
  font-size: 0.18rem;
}

.popup .step3_content .tips span {
  cursor: pointer;
  color: #4d4fff;
  white-space: nowrap;
}

.popup .step4_content {
  margin-bottom: 0.4rem;
}

.popup .step4_content .status_title {
  font-weight: 500;
  font-size: 0.24rem;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup .step4_content .status_title .status_icon {
  margin-left: 0.08rem;
  width: 0.26rem;
  height: 0.26rem;
  border-radius: 50%;
  background: #00c308;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup .step4_content .status_title .status_icon img {
  width: 0.14rem;
  height: auto;
}

.popup .step4_content .status_content {
  margin-top: 0.16rem;
  font-size: 0.18rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
}

.popup .submit_content {
  display: flex;
}

.popup .submit_content .submit_btn {
  height: 0.42rem;
}

.popup.step3 {
  width: 6.54rem;
}
.loan_wrapper.mobile {
    padding-top: .92rem;
    padding-bottom: 1.16rem;
    padding-left: .24rem;
    padding-right: .24rem;
    width: 100%;
    box-sizing: border-box
}


.loan_borrow.mobile .money_content .money_value {
    font-size: .32rem;
    text-align: left;
    color: var(--text-primary);
    font-weight: 700
}

.loan_borrow.mobile .money_content .ver_status_content {
    align-items: flex-start
}

.loan_borrow.mobile .money_content .ver_status_content .status_done {
    margin-top: .06rem;
    color: var(--success-color);
    font-size: .18rem
}

.loan_borrow.mobile .money_content .ver_status_content .status_not {
    display: flex;
    flex-direction: column;
    align-items: flex-start
}

.loan_borrow.mobile .money_content .ver_status_content .status_not .ver_tips {
    margin-top: .06rem;
    color: var(--text-primary);
    font-size: .16rem
}

.loan_borrow.mobile .money_content .ver_status_content .status_not .ver_button {
    margin-top: .16rem;
    height: .5rem
}

.loan_borrow.mobile .select_button_content {
    width: 100%;
    margin-top: .26rem;
    position: relative
}

.loan_borrow.mobile .select_button_content .select_button {
    margin-bottom: .04rem;
    padding: 0 .06rem;
    box-sizing: border-box;
    width: 100%;
    height: .58rem;
    background: var(--card-bg);
    box-shadow: 0 .14rem .24rem var(--card-shadow);
    border-radius: .16rem;
    overflow: hidden
}

.loan_borrow.mobile .select_button_content .select_button .label {
    padding-left: .22rem;
    color: var(--text-primary);
    font-size: .14rem
}

.loan_borrow.mobile .select_button_content .select_button input {
    margin-right: .06rem;
    height: .46rem;
    border-radius: .14rem;
    background: transparent;
    color: var(--text-primary);
    border: none;
    padding-left: .22rem;
    flex: 1
}

.loan_borrow.mobile .select_button_content .select_button input::placeholder {
    color: var(--text-secondary)
}

.loan_borrow.mobile .select_button_content .select_button .select {
    padding: 0 .24rem;
    min-width: .66rem;
    background: var(--bg-secondary);
    color: var(--text-primary)
}

.loan_borrow.mobile .select_button_content .select_button .select span {
    color: var(--text-primary)
}

.loan_borrow.mobile .select_button_content .select_button .select .icon_arrow {
    margin-left: .1rem;
    width: .08rem;
    height: auto
}

.loan_borrow.mobile .select_button_content .select_button .select_options {
    position: absolute;
    top: 1.24rem;
    right: .06rem;
    background: var(--card-bg);
    color: var(--text-primary);
    box-shadow: 0 .14rem .24rem var(--card-shadow);
    border-radius: .16rem;
    overflow: hidden
}

.loan_borrow.mobile .select_button_content .select_button .select_options .option {
    min-width: .66rem;
    padding: .1rem .24rem;
    color: var(--text-primary);
    cursor: pointer;
}

.loan_borrow.mobile .select_button_content .select_button .select_options .option.active,.loan_borrow.mobile .select_button_content .select_button .select_options .option:hover {
    background: var(--hover-bg);
    color: var(--text-primary);
}

.loan_borrow.mobile .info_content {
    margin-top: .26rem;
    text-align: left
}

.loan_borrow.mobile .info_content .info_item {
    margin-bottom: .16rem
}

.loan_borrow.mobile .info_content .tips {
    margin-top: .16rem;
    color: var(--text-secondary);
    font-size: .16rem
}

.loan_borrow.mobile .button_content {
    margin-top: .26rem;
    justify-content: flex-start
}

.loan_borrow.mobile .button_content .submit_btn {
    height: .62rem
}

.account {
	padding-bottom: .4rem
}

.main .content {
	width: 7.87rem;
	margin: auto;
	margin-top: 1.15rem;
}

.main .content .select-button {
	position: relative;
	display: flex;
	justify-content: space-between;
}

.main .content .select-button .down-button {
	max-width: 100%;
	padding: 0.08rem;
	box-sizing: border-box;
	background: var(--bg-secondary);
	border-radius: 0.2rem;
}

.main .content .select-button .down-button .button-active {
	max-width: 100%;
	padding: 0.18rem 0.16rem;
	background: var(--card-bg);
	box-shadow: 0 0.1rem 0.14rem rgba(0, 0, 0, 0.12);
	border-radius: 0.16rem;
	display: flex;
	align-items: center;
}
.main .content .select-button .down-button2{
	display: flex;
}
.main .content .select-button .down-button2 .button-active2 {
	max-width: 100%;
	padding: 0.18rem 0.16rem;
	background: var(--card-bg);
	
	display: flex;
	align-items: center;
}
.main .content .select-button .down-button .button-active .active-name {
	max-width: 100%;
	height: 0.2rem;
	font-weight: 500;
	font-size: 0.16rem;
	color: var(--text-primary);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.main .content .select-button .down-button .button-active img {
	margin-left: 0.1rem;
}

.main .content .select-button .select-lists {
	position: absolute;
	top: 0.68rem;
	left: 0.08rem;
	background: var(--card-bg);
	box-shadow: 0 0.34rem 0.84rem rgba(0, 0, 0, 0.1);
	border-radius: 0.1rem;
	padding: 0.22rem;
	z-index: 3;
}

.main .content .select-button .select-lists .select-list {
	font-weight: 500;
	font-size: 0.16rem;
	color: rgba(0, 0, 0, 0.5);
	margin-bottom: 0.28rem;
}

.main .content .select-button .select-lists .select-list:last-child {
	margin-bottom: 0;
}

.main .content .select-button .select-lists .select-list-active {
	color: var(--text-primary);
}

.main .content .descriptions {
	width: 7.15rem;
	background: #000;
	border-radius: 0.2rem;
	margin-top: 0.14rem;
	padding: 0.36rem;
	position: relative;
	overflow: hidden;
}

.main .content .descriptions .descriptions-title {
	font-weight: 700;
	font-size: 0.28rem;
	color: var(--text-on-primary);
	position: relative;
	z-index: 2;
	height: 0.28rem;
	line-height: 0.28rem;
}

.main .content .descriptions .descriptions-lists {
	margin-top: 0.22rem;
	display: flex;
	justify-content: space-between;
	position: relative;
	z-index: 2;
}

.main .content .descriptions .descriptions-lists .list:last-child {
	margin-right: 0;
}

.main .content .descriptions .descriptions-lists .list .list-lable {
	font-size: 0.16rem;
	line-height: 100%;
	color: hsla(0, 0%, 100%, 0.5);
}

.main .content .descriptions .descriptions-lists .list .list-lable-mobile {
	background: linear-gradient(180deg, #ffdc61, #ffbc49);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.main .content .descriptions .descriptions-lists .list .list-content {
	margin-top: 0.08rem;
	font-weight: 500;
	font-size: 0.18rem;
	line-height: 100%;
	color: var(--text-on-primary);
}

.main .content .descriptions:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-130deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	right: -0.35rem;
	top: -0.5rem;
}

.main .content .descriptions:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	left: 0.95rem;
	bottom: -0.5rem;
}

.main .content .descriptions1 {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	/* background-image: url(../../static/img/noise.90f9bf5b.png); */
	z-index: 1;
}

.order-main {
	margin-top: .66rem
}

.order-main .title {
	font-weight: 700;
	font-size: .42rem;
	line-height: 100%;
	color: var(--text-primary);
	margin-bottom: .22rem
}

.order-main .tabs-content {
	display: flex
}

.order-main .tabs-content .tabs {
	/* height: .52rem; */
	background: var(--bg-secondary);
	border-radius: .2rem;
	display: flex;
	align-items: center;
	// justify-content: space-between;
	padding: .08rem
}



.order-main .tabs-content .tabs .tab-active {
	background: var(--card-bg);
	box-shadow: 0 .1rem .14rem rgba(0, 0, 0, .12);
	border-radius: .16rem;
	color: var(--text-primary)
}

.order-main .collapse {
	margin-top: .2rem
}

.order-main .collapse .collapse-item {
	width: 7.87rem;
	margin-bottom: .1rem
}

.order-main .show-more {
	margin-top: .2rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.order-main .show-more span {
	padding-bottom: .04rem;
	font-size: .18rem;
	color: var(--text-primary)
}

.order-main .show-more img {
	cursor: pointer;
	margin-left: .08rem
}

.setting-main {
	margin-top: .46rem
}

.setting-main .title {
	font-weight: 700;
	font-size: .42rem;
	line-height: 100%;
	color: var(--text-primary);
	margin-bottom: .22rem
}

.setting-main .content-lists {
	margin-top: .2rem;
	font-weight: 500;
	font-size: .2rem;
	color: var(--text-on-primary);
}

.setting-main .content-lists .list {
	cursor: pointer;
	width: 7.39rem;
	margin-bottom: .04rem;
	background: #000;
	border-radius: .2rem;
	padding: .24rem;
	display: flex;
	align-items: center;
	justify-content: space-between
}

.setting-main .content-lists .login-out {
	font-weight: 400;
	font-size: .18rem;
	height: .18rem;
	line-height: .18rem;
	color: #ff5858;
	text-align: center;
	margin-top: .24rem;
	cursor: pointer
}

.setting-main .mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .4);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999
}

.setting-main .mask .account_verification {
	background: var(--card-bg);
	border-radius: .18rem
}

.underline {
	border-bottom: 0.01rem solid #ffbc49;
}

.underline1 {
	border-bottom: 0.01rem solid #f2f2f2;
}


.collapse-content {
	width: 100%;
	/* ✅ 去除边框，改用灰色背景 */
	background: var(--bg-secondary);
	border-radius: .2rem;
	padding: .16rem .2rem;
	box-sizing: border-box;
	margin-bottom: .16rem;
}

.collapse-content .info-type-fail {
	color: #ff5858
}

.collapse-content .info-type-success {
	color: #379000
}

.collapse-content .content-header {
	cursor: pointer;
	position: relative
}

.collapse-content .content-header .order-top {
	display: flex;
	justify-content: space-between;
	align-items: center
}

.collapse-content .content-header .order-top .order-number {
	font-weight: 400;
	font-size: .14rem;
	color: var(--text-secondary)
}

.collapse-content .content-header .order-top .right-top {
	font-weight: 400;
	font-size: .14rem;
	color: var(--text-primary)
}

.collapse-content .content-header .order-top .right-top .ml-16 {
	margin-left: .16rem
}

.collapse-content .content-header .currency-info {
	margin-top: .12rem;
	color: var(--text-primary);
	display: flex;
	align-items: center
}

.collapse-content .content-header .currency-info .info-type {
	font-weight: 500;
	font-size: .16rem;
	margin-right: .2rem
}

.collapse-content .content-header .currency-info .info-type:last-child {
	margin-right: 0
}

.collapse-content .content-header .currency-info .info-type.coin-name {
	font-weight: 700;
	font-size: .2rem
}

.collapse-content .content-header .currency-info .info-type-svg .info-type-round {
	width: 100%;
	height: 100%;
	line-height: 100%;
	text-align: center;
	font-size: .12rem
}

.collapse-content .content-header .currency-info .info-number {
	font-weight: 500;
	font-size: .16rem
}

.collapse-content .content-header .result {
	margin-top: .12rem;
	margin-bottom: .04rem
}

.collapse-content .content-header .result span {
	font-weight: 400;
	font-size: .14rem;
	margin-right: .16rem;
	color: var(--text-primary)
}

.collapse-content .content-header .down-icon {
	position: absolute;
	bottom: -.04rem;
	right: 0
}

.collapse-content .content-header .down-icon img {
	width: .12rem;
	height: .06rem
}

.collapse-content .content-body {
	border-top: .01rem solid rgba(0, 0, 0, .2);
	margin-top: .22rem;
	padding-top: .22rem
}

.collapse-content .content-body .body-list {
	font-weight: 500;
	font-size: .16rem;
	margin-bottom: .22rem;
	display: flex;
	justify-content: space-between;
	color: var(--text-primary)
}

.collapse-content .content-body .body-list .size-18 {
	font-weight: 500;
	font-size: .18rem
}

.collapse-content .content-body .body-list .red-color {
	color: #ff5858
}

.collapse-content .content-body .body-list .list-right {
	text-align: right
}

.collapse-content .content-body .close-button {
	width: max-content;
	padding: 0 .36rem;
	height: .5rem;
	background: linear-gradient(180deg, #ffdc61, #ffbc49);
	border-radius: .25rem;
	font-weight: 500;
	font-size: .18rem;
	color: var(--text-primary);
	text-align: center;
	line-height: .5rem;
	margin-bottom: .08rem
}

.collapse-content .content-body .close-early {
	width: 2.18rem
}

.collapse-content .content-body .close-Recreate {
	width: 2.58rem
}

.collapse-content .content-body .order-button {
	width: max-content;
	height: .48rem;
	padding: 0 .7rem;
	border: .02rem solid #000;
	border-radius: .25rem;
	font-weight: 500;
	font-size: .18rem;
	color: var(--text-primary);
	text-align: center;
	line-height: .5rem;
	margin-top: .32rem
}

.collapse-content .content-body .order-button img {
	width: .12rem;
	height: .06rem;
	vertical-align: middle
}

.collapse-content .content-body .order-button1 {
	margin-top: .1rem
}

.collapse-content .content-body .body-p {
	font-weight: 300;
	font-size: .16rem;
	color: rgba(0, 0, 0, .8);
	margin-top: .14rem;
	width: 2.9rem;
	line-height: .24rem
}

.collapse-content.mobile {
	padding: .2rem .22rem
}

.collapse-content.mobile .content-header .currency-info .info-type {
	margin-right: .1rem
}

.collapse-content.mobile .content-body .close-button {
	background: #000;
	color: var(--text-on-primary)
}

.order-main {
	margin-top: .66rem
}

.order-main .title {
	font-weight: 700;
	font-size: .42rem;
	line-height: 100%;
	color: var(--text-primary);
	margin-bottom: .22rem
}

.order-main .tabs-content {
	display: flex
}



.order-main .tabs-content .tabs .tab {
	cursor: pointer;
	font-weight: 500;
	font-size: .16rem;
	line-height: 100%;
	text-align: center;
	color: #949494;
	padding: .18rem .16rem
}

.order-main .tabs-content .tabs .tab-active {
	background: var(--card-bg);
	box-shadow: 0 .1rem .14rem rgba(0, 0, 0, .12);
	border-radius: .16rem;
	color: var(--text-primary)
}

.order-main .collapse {
	margin-top: .2rem
}

.order-main .collapse .collapse-item {
	width: 7.87rem;
	margin-bottom: .1rem
}

.order-main .show-more {
	margin-top: .2rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.order-main .show-more span {
	padding-bottom: .04rem;
	font-size: .18rem;
	color: var(--text-primary)
}

.order-main .show-more img {
	cursor: pointer;
	margin-left: .08rem
}

.order-main-mobile {
	width: 100%;
	margin: auto;
	margin-top: .36rem;
	height: max-content
}

.order-main-mobile .title {
	font-size: .26rem
}

.order-main-mobile .tabs {
	// width: 100%;
	background: #000;
	overflow-y: auto
}

.order-main-mobile .tabs .tab {
	white-space: nowrap;
	color: var(--text-on-primary)
}

.order-main-mobile .tabs .tab-active {
	color: var(--text-primary)
}

.order-main-mobile .tabs::-webkit-scrollbar {
	display: none
}

.order-main-mobile .collapse {
	width: 100%;
	min-height: 1.14rem
}

.order-main-mobile .collapse .collapse-item {
	width: 100%
}

.main-mobile {
	padding: 0 .28rem
}

.main-mobile .content-mobile {
	width: 100%;
	margin: auto;
	margin-top: .9rem
}

.main-mobile .content-mobile .down-button {
	background: #000 !important
}

.main-mobile .content-mobile .descriptions-mobile {
	width: 100%;
	box-sizing: border-box;
	padding: .32rem .28rem;
	position: relative;
	overflow: hidden
}

.main-mobile .content-mobile .descriptions-mobile .descriptions-lists {
	margin-top: 0;
	flex-wrap: wrap
}

.main-mobile .content-mobile .descriptions-mobile .descriptions-lists .list {
	margin-right: 0;
	width: 1.6rem;
	margin-top: .22rem
}

.main-mobile .content-mobile .descriptions-mobile .descriptions-lists .list .list-lable-mobile {
	background: linear-gradient(180deg, #ffdc61, #ffbc49);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text
}

.main-mobile .content-mobile .descriptions-mobile:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-130deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	right: -.35rem;
	top: -.5rem
}

.main-mobile .content-mobile .descriptions-mobile:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: 1.3rem;
	bottom: -.6rem
}

.setting-main-mobile {
	width: 100%;
	margin: auto;
	margin-top: .36rem;
	height: max-content;
	margin-bottom: 1.2rem
}

.setting-main-mobile .content-lists .list {
	box-sizing: border-box;
	width: 100%
}


.loan-main {
	width: 100%;
	height: 100%;
	z-index: 999;
	position: fixed;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, .4);
	display: flex;
	justify-content: center;
	align-items: center
}

.loan-main .step1_content {
	padding: .44rem;
	box-sizing: border-box;
	background: var(--card-bg);
	width: 8.62rem;
	border-radius: .18rem;
	max-height: 80%;
	overflow: auto
}

.loan-main .step1_content .loan_title {
	margin-bottom: .36rem;
	font-weight: 700;
	font-size: .34rem;
	color: var(--text-primary)
}

.loan-main .step1_content .collapse {
	margin-bottom: .1rem
}

/* ✅ 贷款记录卡片样式 - 去除边框 */
.loan-main .step1_content .collapse .collapse-content {
	background: var(--bg-secondary);
	border-radius: 12px;
	margin-bottom: 16px;
	padding: 20px;
	transition: all 0.3s ease;
}

.loan-main .step1_content .collapse .collapse-content .content-header {
	position: relative;
}

/* ✅ 订单顶部：订单号和状态 */
.loan-main .step1_content .collapse .collapse-content .content-header .order-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	/* ✅ 去除下边框线 */
}

.loan-main .step1_content .collapse .collapse-content .content-header .order-top .order-number {
	font-weight: 600;
	font-size: 16px;
	color: var(--text-primary);
}

/* ✅ 状态徽章样式 */
.loan-main .step1_content .status-badge {
	padding: 5px 14px;
	border-radius: 14px;
	font-size: 13px;
	font-weight: 500;
	display: inline-block;
}

.loan-main .step1_content .status-badge.status-pending {
	background: rgba(255, 152, 0, 0.1);
	color: #ff9800;
}

.loan-main .step1_content .status-badge.status-processing {
	background: rgba(33, 150, 243, 0.1);
	color: #2196f3;
}

.loan-main .step1_content .status-badge.status-success {
	background: rgba(76, 175, 80, 0.1);
	color: #4caf50;
}

.loan-main .step1_content .status-badge.status-rejected {
	background: rgba(244, 67, 54, 0.1);
	color: #f44336;
}

/* ✅ 贷款详情：清晰的两列布局 */
.loan-main .step1_content .loan-details {
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 12px;
}

.loan-main .step1_content .detail-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 4px 0;
}

.loan-main .step1_content .detail-label {
	font-size: 14px;
	color: var(--text-secondary);
	font-weight: 400;
}

.loan-main .step1_content .detail-value {
	font-size: 15px;
	color: var(--text-primary);
	font-weight: 500;
	text-align: right;
}

.loan-main .step1_content .detail-value.highlight {
	color: var(--primary-color);
	font-weight: 600;
	font-size: 16px;
}

/* ✅ 申请时间 */
.loan-main .step1_content .order-time {
	margin-top: 12px;
	/* ✅ 去除上边框线 */
	font-size: 13px;
	color: var(--text-secondary);
	text-align: right;
}

.loan-main .step1_content .collapse .collapse-content .content-header .down-icon {
	position: absolute;
	bottom: -.04rem;
	right: 0
}

.loan-main .step1_content .collapse .collapse-content .content-header .down-icon img {
	width: .12rem;
	height: .06rem
}

.loan-main .step1_content .collapse .collapse-content .content-header .down-icon img.active {
	transform: rotate(180deg)
}

.loan-main .step1_content .collapse .collapse-content .content-body {
	border-top: .01rem solid rgba(0, 0, 0, .2);
	margin-top: .22rem;
	padding-top: .22rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-list {
	font-weight: 500;
	font-size: .16rem;
	margin-bottom: .22rem;
	display: flex;
	justify-content: space-between;
	color: var(--text-primary)
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-list .size-18 {
	font-weight: 500;
	font-size: .18rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-list .list-left .info-type-fail,
.loan-main .step1_content .collapse .collapse-content .content-body .body-list .red-color {
	color: #ff5858
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-list .list-left .info-type-success {
	color: #379000
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-list .list-right {
	text-align: right
}

.loan-main .step1_content .collapse .collapse-content .content-body .close-button {
	width: max-content;
	padding: 0 .36rem;
	height: .5rem;
	background: linear-gradient(180deg, #ffdc61, #ffbc49);
	border-radius: .25rem;
	font-weight: 500;
	font-size: .18rem;
	color: var(--text-primary);
	text-align: center;
	line-height: .5rem;
	margin-bottom: .08rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .close-early {
	width: 2.18rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .close-Recreate {
	width: 2.58rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .order-button {
	width: max-content;
	height: .48rem;
	padding: 0 .7rem;
	border: .02rem solid #000;
	border-radius: .25rem;
	font-weight: 500;
	font-size: .18rem;
	color: var(--text-primary);
	text-align: center;
	line-height: .5rem;
	margin-top: .32rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .order-button img {
	width: .12rem;
	height: .06rem;
	vertical-align: middle
}

.loan-main .step1_content .collapse .collapse-content .content-body .order-button1 {
	margin-top: .1rem
}

.loan-main .step1_content .collapse .collapse-content .content-body .body-p {
	font-weight: 300;
	font-size: .16rem;
	color: rgba(0, 0, 0, .8);
	margin-top: .14rem;
	width: 2.9rem;
	line-height: .24rem
}

.loan-main .step1_content .show-more {
	margin-top: .2rem;
	display: flex;
	justify-content: center;
	align-items: center
}

.loan-main .step1_content .show-more span {
	padding-bottom: .04rem;
	font-size: .16rem;
	color: var(--text-primary)
}

.loan-main .step1_content .show-more img {
	cursor: pointer;
	margin-left: .08rem
}

.loan-main .step2_content {
	padding: .44rem;
	box-sizing: border-box;
	background: var(--card-bg);
	width: 8.62rem;
	border-radius: .18rem;
	max-height: 80%;
	overflow: auto
}

.loan-main .step2_content .title {
	font-weight: 700;
	font-size: .34rem;
	color: var(--text-primary);
	text-align: center
}

.loan-main .step2_content .box-content {
	margin-top: .5rem;
	display: flex;
	flex-wrap: wrap;
	justify-content: center
}

.loan-main .step2_content .box-content .info {
	text-align: center;
	float: left;
	margin: .2rem .15rem
}

.loan-main .step2_content .box-content .info .info-labe {
	font-weight: 400;
	font-size: .18rem;
	color: var(--text-secondary)
}

.loan-main .step2_content .box-content .info .info-content {
	font-weight: 700;
	font-size: .24rem;
	color: var(--text-primary);
	margin-top: .05rem
}

.loan-main .step2_content .buttons {
	margin-top: .44rem;
	display: flex;
	justify-content: center;
	font-size: .18rem;
	line-height: .5rem;
	text-align: center;
	color: var(--text-primary)
}

.loan-main .step2_content .buttons .down-button {
	width: 1.94rem;
	height: .5rem;
	background: linear-gradient(180deg, #ffdc61, #ffbc49);
	border-radius: .25rem;
	margin: 0 .05rem
}

.loan-main .step2_content .buttons .agree-button {
	width: 1.65rem;
	height: .5rem;
	border: .01rem solid var(--border-color);
	border-radius: .25rem;
	margin: 0 .05rem
}

.loan-main-mobile {
	padding: .24rem;
	padding-top: .9rem;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	z-index: 999;
	position: fixed;
	left: 0;
	top: 0;
	background: var(--bg-primary);
	overflow: auto;
	display: block
}

.loan-main-mobile .step1_content {
	padding: 0;
	width: 100%;
	height: auto;
	max-height: fit-content;
	overflow: hidden
}

.loan-main-mobile .step1_content .collapse .collapse-content .content-header .currency-info .info-type {
	margin: 0 .1rem
}

.loan-main-mobile .step1_content .collapse .collapse-content .content-body .close-button {
	background: #000;
	color: var(--text-on-primary)
}

.loan-main-mobile .step2_content {
	width: 100%;
	padding: .32rem .24rem;
	border: .01rem solid var(--border-color);
	max-height: fit-content;
	box-sizing: border-box;
	border-radius: .18rem;
	overflow: hidden
}

.loan-main-mobile .step2_content .box-content {
	flex-wrap: nowrap;
	flex-direction: column;
	margin-top: 0
}

.loan-main-mobile .step2_content .box-content .info {
	margin: 0;
	margin-bottom: .2rem
}

.loan-main-mobile .step2_content .buttons {
	margin-top: .08rem
}

.loan-main-mobile .step2_content .buttons .down-button {
	background: #000;
	color: var(--text-on-primary);
	border-radius: .2rem
}

.loan-main-mobile .step2_content .buttons .agree-button {
	border-radius: .2rem
}

.language-main {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, .4);
	display: flex;
	justify-items: center;
	align-items: center;
	justify-content: center
}

.language-main .content {
	width: 4.32rem;
	background: #000;
	border-radius: .16rem;
	padding: .24rem .32rem;
	color: var(--text-on-primary);
	text-align: center
}

.language-main .content .title {
	font-weight: 500;
	font-size: .2rem;
	margin-bottom: .18rem
}

.language-main .content .content-box {
	cursor: pointer;
	width: 3.16rem;
	margin: auto
}

.language-main .content .content-box .box {
	width: 3.16rem;
	height: .46rem;
	border-radius: .24rem;
	line-height: .46rem;
	margin-bottom: .16rem
}

.language-main .content .content-box .box-active {
	background: var(--card-bg);
	color: var(--text-primary)
}

.language-main-mobile {
	z-index: 11
}

.language-main-mobile .content {
	max-height: 80%;
	overflow: auto
}


.account[data-v-1791f49f] {
	padding-bottom: .4rem
}

:deep(.el-progress--circle .el-progress__text),
:deep(.el-progress--dashboard .el-progress__text) {
	font-size: 0.16rem !important;
}

.loan-main-mobiles {
	.result {
		display: flex;
		flex-direction: column;

		span {
			margin-bottom: 10px;
		}

	}


}
.item-ul[data-v-8acaa578] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex
;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: .4rem 0 .5rem;
}
.item-ul .item-tab[data-v-8acaa578] {
    width: 50%;
    text-align: center;
}

li {
    list-style: none;
}
.item-ul .item-tab .icon[data-v-8acaa578] {
    width: .50rem;
    height: .50rem;
    margin-bottom: .1rem;
}
.font-32 {
    font-size: .15rem;
}
.c-000 {
    color: var(--text-primary);
}
.collapse .tabs-content{
	padding: 10px 0px ;
}
.button.black {

    float: left;
    margin: 0 10px;
    width:43%
}
.submit_btn{
  width: 100%;
}

/* 按钮样式 - 适配主题 */
.button.black,
.button.round,
.button.yellow {
  background: var(--primary-color) !important;
  color: var(--text-on-primary) !important;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.button.black:hover,
.button.round:hover,
.button.yellow:hover {
  background: var(--primary-dark) !important;
  transform: translateY(-1px);
}

.button.black:active,
.button.round:active,
.button.yellow:active {
  transform: translateY(0);
}

/* ✅ 黑夜模式适配 */
.dark-mode .loan-main .step1_content .collapse .collapse-content {
	background: rgba(255, 255, 255, 0.05);
}

.dark-mode .loan-main .step1_content .status-badge.status-pending {
	background: rgba(255, 152, 0, 0.15);
	color: #ffb74d;
}

.dark-mode .loan-main .step1_content .status-badge.status-processing {
	background: rgba(33, 150, 243, 0.15);
	color: #64b5f6;
}

.dark-mode .loan-main .step1_content .status-badge.status-success {
	background: rgba(76, 175, 80, 0.15);
	color: #81c784;
}

.dark-mode .loan-main .step1_content .status-badge.status-rejected {
	background: rgba(244, 67, 54, 0.15);
	color: #e57373;
}

/* ✅ 黑夜模式适配 - 通用贷款记录卡片 */
.dark-mode .collapse-content {
	background: rgba(255, 255, 255, 0.05);
}
</style>